var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0893 3.51668L12.5211 6.09345C12.7172 6.44715 13.2096 6.78313 13.6145 6.82855L16.0245 7.13005C17.5675 7.31976 17.9655 8.40964 16.9153 9.55121L15.1262 11.4851C14.8275 11.8092 14.6725 12.4275 14.7925 12.8519L15.4194 15.1287C15.9124 16.9263 14.9748 17.6714 13.3269 16.7885L11.0251 15.5548C10.6058 15.3293 9.9399 15.3621 9.54604 15.6153L7.35476 17.0269C5.78608 18.0359 4.78788 17.3716 5.13209 15.5414L5.57285 13.2252C5.65514 12.7922 5.45785 12.188 5.1322 11.8908L3.189 10.1101C2.04871 9.06114 2.35543 7.94311 3.87492 7.62613L6.24751 7.1329C6.64793 7.04634 7.11194 6.68105 7.27486 6.30939L8.49041 3.61971C9.14417 2.16772 10.3163 2.12208 11.0893 3.51668Z",
    fill: "#8392A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2653f9f13d1601b40520ae267d3e788b.svg";
export { ForwardRef as ReactComponent };